import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=fdaf3a94&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=fdaf3a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaf3a94",
  null
  
)

export default component.exports